import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import FeesBreakdownDetailsIcon from './fees-breakdown-details';
import PaymentSchedule from '../../../containers/member-payments-schedule-link.container';
import CurrencyConversion from '../../../containers/currency-conversion.container';

import money, { format } from '../../../lib/money';
import { Time, TIME_FORMAT_SHORT } from '../../../../components/Time';
import Purchase from '../../../lib/purchase';
import getCardTypeName from '../../../lib/card-type-names';
import { SHARED_NAMESPACE } from '../../../actions'

import { formatMessage } from '../../../lib/intl';

const i18n = defineMessages({
  nextPaymentLine2: {
    id: 'summaryShare.charged.nextContribution.nextPayment.line2',
    defaultMessage: ' to your {cardType} ending in {lastFour}',
  },
});

class SummaryShareCharged extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }
  get isRefund() {
    return this.nextPaymentAmount && this.nextPaymentAmount.isZero()
      && this.refundableAmount && !this.refundableAmount.isZero();
  }

  get contributionAmount() { return money(this.props.contributionAmount); }

  get nextPaymentAmount() {
    const { nextPayment } = this.props;

    if (!nextPayment) return;

    return money(nextPayment.amount);
  }

  get refundableAmount() {
    const { refundableAmount } = this.props;

    if (!refundableAmount) return;
    return money(refundableAmount);
  }

  renderFeesBreakdownDetails() {
    const { fees: { consumerFee }, shareAmount, claimedSlots, amount } = this.props.membership;
    const { splitType, currentProductCostAmount } = this.props;
    const costPerSlot = Purchase.isFixedPerPerson(splitType) ? currentProductCostAmount : null;

    return (
      <FeesBreakdownDetailsIcon
        amount={amount}
        shareAmount={shareAmount}
        costPerSlot={costPerSlot}
        claimedSlots={claimedSlots}
        feesAmount={consumerFee}
      />
    );
  }

  renderNextContribution() {
    const { membership, nextPayment } = this.props;
    const { paymentSource } = membership;

    if (!nextPayment) return;
    if (Purchase.isDateExpired(nextPayment.dueDeadline)) return;

    const nextDate = <Time format={TIME_FORMAT_SHORT} time={nextPayment.dueDeadline} />;
    const amount = format(this.nextPaymentAmount);
    const cardType = getCardTypeName(paymentSource.info.cardType);

    return (
      <p className="mt-3 mb-0 small-print card-icons">
        <FormattedMessage
          id='summaryShare.charged.nextContribution.nextPayment.line1'
          defaultMessage='Next payment will be {amount}, on or before {nextDate}'
          values={{
            amount,
            nextDate,
          }}
        />
        {' '}
        {this.formatMessage(i18n.nextPaymentLine2, { cardType, lastFour: paymentSource.info.lastFour })}
      </p>
    );
  }

  renderRefund() {
    const { nextPayment } = this.props;
    if (!nextPayment) return;
    if (Purchase.isDateExpired(nextPayment.dueDeadline)) return;

    const nextDate = <Time format={TIME_FORMAT_SHORT} time={nextPayment.dueDeadline} />;
    return (
      <p className="mt-3 mb-0 small-print">
        <FormattedMessage
          id="summaryShare.charged.nextContribution.isRefund"
          defaultMessage="Next payment will be a refund to you of {amount} on or before {date}"
          values={{
            amount: format(this.refundableAmount),
            date: nextDate,
          }}
        />
      </p>
    );
  }

  renderPaymentSchedule() {
    return (
      <div>
        <PaymentSchedule namespace={SHARED_NAMESPACE} />
      </div>
    );
  }

  render() {
    const { membership: { paymentSource } } = this.props;
    const date = (<Time format={TIME_FORMAT_SHORT} time={this.props.paymentDate} />);
    return (
      <div className="summary-share-charged yourshare-block gray">
        <div className="yourshare-box pt-4">
          <div className="contribute text-center">
            <div>
              <FormattedMessage
                id="summaryShare.charged.title"
                defaultMessage="You were charged"
              /> {this.renderFeesBreakdownDetails()}
            </div>
            <div>
              <h2>
                {format(this.contributionAmount)} <CurrencyConversion amount={this.contributionAmount} />
              </h2>
              <p className="mb-4 small-print card-icons">
                <FormattedMessage
                  id='summaryShare.charged.chargedOnCard'
                  defaultMessage='On {date} to your {cardType} ending in {lastFour}'
                  values={{
                    date,
                    cardType: getCardTypeName(paymentSource.info.cardType),
                    lastFour: paymentSource.info.lastFour,
                  }}
                />
              </p>
              {
                this.isRefund ? this.renderRefund() : this.renderNextContribution()
              }
              {this.renderPaymentSchedule()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SummaryShareCharged);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/summary-share.charged.js